import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Heart, X, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const MatchModal = ({ isOpen, onClose, matchedUser, matchId }) => {
  const navigate = useNavigate();

  const handleMessage = () => {
    onClose();
    navigate(`/chat/${matchId}`);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/80"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            className="relative bg-dark-paper rounded-3xl p-8 max-w-sm w-full border border-gold/30 shadow-[0_0_40px_rgba(212,175,55,0.2)]"
            onClick={(e) => e.stopPropagation()}
            data-testid="match-modal"
          >
            {/* Close button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white transition-colors"
            >
              <X className="w-6 h-6" />
            </button>

            {/* Hearts animation */}
            <div className="flex justify-center mb-6">
              <motion.div
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ repeat: Infinity, duration: 1.5 }}
              >
                <Heart className="w-20 h-20 text-gold fill-gold" />
              </motion.div>
            </div>

            {/* Title */}
            <h2 className="font-heading text-3xl text-center text-gold-gradient mb-2">
              It's a Match!
            </h2>
            <p className="text-center text-gray-400 mb-6 font-body">
              You and {matchedUser?.name} liked each other
            </p>

            {/* Profile photo */}
            {matchedUser?.photo && (
              <div className="flex justify-center mb-6">
                <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-gold shadow-[0_0_20px_rgba(212,175,55,0.3)]">
                  <img
                    src={matchedUser.photo}
                    alt={matchedUser.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            )}

            {/* Action buttons */}
            <div className="flex gap-4">
              <button
                onClick={onClose}
                className="flex-1 py-3 px-4 border border-white/20 rounded-full text-white font-body font-medium hover:bg-white/5 transition-colors"
                data-testid="keep-swiping-btn"
              >
                Keep Swiping
              </button>
              <button
                onClick={handleMessage}
                className="flex-1 py-3 px-4 btn-gold rounded-full flex items-center justify-center gap-2"
                data-testid="send-message-btn"
              >
                <MessageCircle className="w-5 h-5" />
                Message
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MatchModal;
